/** In-memory, bounded history. Snapshots are immutable and share unchanged blocks. */
export class EditorHistory<T> {
  private past: T[] = [];
  private future: T[] = [];
  private group?: { key: string; at: number };
  constructor(private limit = 100, private typingWindowMs = 1000) {}
  get canUndo() { return this.past.length > 0; }
  get canRedo() { return this.future.length > 0; }
  breakGroup() { this.group = undefined; }
  clear() { this.past = []; this.future = []; this.breakGroup(); }
  record(before: T, key?: string, now = Date.now()) {
    if (!key || this.group?.key !== key || now - this.group.at > this.typingWindowMs) {
      this.past.push(before);
      if (this.past.length > this.limit) this.past.shift();
    }
    this.future = [];
    this.group = key ? { key, at: now } : undefined;
  }
  undo(current: T): T | undefined {
    this.breakGroup();
    if (!this.canUndo) return;
    this.future.push(current);
    return this.past.pop();
  }
  redo(current: T): T | undefined {
    this.breakGroup();
    if (!this.canRedo) return;
    this.past.push(current);
    return this.future.pop();
  }
}

export function historyShortcut(event: { key: string; ctrlKey: boolean; metaKey: boolean; altKey: boolean; shiftKey: boolean; isComposing?: boolean }) {
  if (event.isComposing || event.altKey || !(event.ctrlKey || event.metaKey)) return null;
  const key = event.key.toLowerCase();
  if (key === "z") return event.shiftKey ? "redo" : "undo";
  if (key === "y" && event.ctrlKey && !event.metaKey && !event.shiftKey) return "redo";
  return null;
}
